<template>
  <div class="main-content">
    <!-- Section: inner-header -->
    <!-- class="inner-header divider parallax layer-overlay overlay-dark-5 pt-70 img-background-50" 
    (contacts)  inner-header divider parallax layer-overlay bg-image-100-size overlay-dark-5 pt-70
    (about me)  inner-header divider parallax layer-overlay overlay-dark-5 pt-100 mobile-parallax
    
    -->
    <section
      v-if="category != null"
      class="inner-header divider parallax layer-overlay overlay-dark-5 pt-100 mobile-parallax"
      data-parallax-ratio="0.7"
      :data-bg-img="baseUrl + category.ImageDetail.url"
      v-bind:style="{ backgroundImage: 'url(' + baseUrl + category.ImageDetail.url + ')' }"
    >
      <div class="container pt-100 pb-50">
        <!-- Section Content -->
        <div class="section-content pt-100">
          <div class="row">
            <div class="col-md-12">
              <h3 class="title text-white">{{category.Title}}</h3>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Section: About -->
    <section id="category" v-if="category != null">
      <div class="container pt-70">
        <div class="section-content">
          <div class="row pb-40">
            <!-- <div class="col-md-1">
              <i class="flaticon-boxing-gym-2 font-72 line-height-1"></i>
            </div>-->
            <div class="col-md-12 description no-style">
            <vue-markdown class="font-18 mt-0 " :source="category.Description"></vue-markdown>
              <!-- <h4 class="text-uppercase mt-0 letter-space-3">
                <vue-markdown :source="item.Description"></vue-markdown>{{category.Description}}</h4> -->
            </div>
          </div>
        </div>
      </div>
    </section>


    <!-- Section: Categories -->
    <section id="categories" v-if="programs != null && programs.length > 0">
      <div class="container">
        <div class="row mtli-row-clearfix">
          <div class="col-md-12">
            
     <!-- <div
        class="m-10"
        data-pp-message
        data-pp-style-layout="flex"
        data-pp-style-ratio="20x1"
        data-pp-style-color="black">
      </div> -->

            <div class="itemContainer">
              <div class="item" v-for="program in programs" :key="program.id">
                <div class="class-item box-hover-effect effect1 mb-md-30 bg-lighter" :class="{ 'is-featured': program.TheBestSelling }">
                  <div class="badge-featured" v-if="program.TheBestSelling">
                    <i class="fa fa-star"></i> Il più scelto
                  </div>
                  <div class="content">
                    <div class="thumb mb-20"><img v-if="program.MainImage"
                      :alt="program.MainImage.alternativeText"
                      :src="baseUrl + program.MainImage.url"
                      class="img-responsive img-fluid img-fullwidth"/>
                        </div>
                    <div class="text-left flip p-25 pt-0">
                    <h4 class="text-uppercase font-weight-800 line-bottom">{{program.Title}}</h4>
                    <p>{{program.Description}}</p>
                     </div>
                    <a :href="'/payment?ID=' + program.id" class="btn-buy btn btn-dark btn-theme-colored btn-xl">ACQUISTA <b>{{program.Price}}€</b></a>
                    <div class="buy-reassurance">
                      <span><i class="fa fa-lock"></i> Pagamento sicuro</span>
                      <span><i class="fa fa-play-circle-o"></i> Inizia quando vuoi</span>
                    </div>
                  </div>
                </div>
              </div>
              </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Section: Gallery -->
    <section id="gallery">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <!-- Portfolio Gallery Grid -->
            <div
              class="gallery-isotope grid-3 masonry gutter-small clearfix"
              data-lightbox="gallery"
            >
              <div v-if="category != null">
                <!-- Portfolio Item Start -->
                <div
                  class="gallery-item"
                  v-for="galleryImg in category.GalleryImages"
                  :key="galleryImg.id"
                >
                  <a
                    :href="baseUrl + galleryImg.url"
                    data-lightbox="gallery-item"
                    :title="galleryImg.alt"
                  >
                    <img :src="baseUrl + galleryImg.url" alt />
                  </a>
                </div>
              </div>
              <!-- Portfolio Item End -->
            </div>
            <!-- End Portfolio Gallery Grid -->
          </div>
        </div>
      </div>
    </section>

    


  </div>
</template>

<style scoped>
.inner-header{
    background-attachment: scroll !important;
    background-position: center center !important;
    background-size: cover !important;
}

/* #category .description, #program .title {
  text-align: center;
} */
#program img {
 max-height: 200px;
}

.content{
  display: flex;
  flex-direction: column;
  height: 100%;
}

.btn-buy{
  margin-top: auto;
  align-self: center;
  margin-bottom: 12px;
}

.buy-reassurance{
  align-self: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  margin-bottom: 20px;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.3px;
  text-transform: uppercase;
  color: #6c757d;
}

.buy-reassurance span{
  display: inline-flex;
  align-items: center;
  white-space: nowrap;
}

.buy-reassurance i{
  color: #2e9e5b;
  margin-right: 5px;
}

.item .class-item{
  border-radius: 5px;
  position: relative;
}

/* Card in evidenza (primo programma) */
.item .class-item.is-featured{
  box-shadow: 0 10px 30px rgba(238, 22, 59, 0.18);
}

.badge-featured{
  position: absolute;
  top: 14px;
  left: 14px;
  display: inline-flex;
  align-items: center;
  background: linear-gradient(135deg, #EE163B, #ff4d6a);
  color: #fff;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.6px;
  text-transform: uppercase;
  padding: 6px 14px;
  border-radius: 50px;
  white-space: nowrap;
  z-index: 3;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.25);
}

.badge-featured i{
  margin-right: 5px;
}

.item{
  margin: 1rem;
  display: flex;
  flex: 1 1 calc(33.333% - 2rem);
  max-width: calc(33.333% - 2rem);
}

.itemContainer{
  display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
}

/* Tablet / dispositivi più piccoli del desktop: max 2 per riga */
@media only screen and (max-width: 991px) {
  .item{
    flex: 1 1 calc(50% - 2rem);
    max-width: calc(50% - 2rem);
  }
}

/* Dispositivi piccoli (smartphone): 1 per riga */
@media only screen and (max-width: 575px) {
  .item{
    flex: 1 1 calc(100% - 2rem);
    max-width: calc(100% - 2rem);
  }
}

#about .title.line-bottom::after {
  height: 2px;
  width: 100%;
}
</style>

<script>
import axios from "axios";
import VueMarkdown from 'vue-markdown'
import { THEMEMASCOT } from "../../public/js/custom.js";

export default {
  name: "Category",
  props: ["CategoryKey"],
  components: {
    VueMarkdown
  },
  data() {
    return {
      category: null,
      programs: null,
      baseUrl: process.env.VUE_APP_API_URL
    };
  },
  async mounted() {
     this.category = await axios
      .get(process.env.VUE_APP_API_URL + "/categories?UrlKey=" + this.CategoryKey)
      .then(response => {
        return JSON.parse(JSON.stringify(response.data))[0];
        
      });

      this.programs = this.category.programs.filter(x => x.IsVisible == true).sort(dynamicSort("Order"));

        THEMEMASCOT.slider.init();
        THEMEMASCOT.widget.init();
  }
};

function dynamicSort(property) {
    var sortOrder = 1;
    if(property[0] === "-") {
        sortOrder = -1;
        property = property.substr(1);
    }
    return function (a,b) {
        /* next line works with strings and numbers, 
         * and you may want to customize it to your needs
         */
        var result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
        return result * sortOrder;
    }
}
</script>